import { render, staticRenderFns } from "./ClinicHistory.vue?vue&type=template&id=64bedc6b&"
import script from "./ClinicHistory.vue?vue&type=script&lang=ts&"
export * from "./ClinicHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bedc6b')) {
      api.createRecord('64bedc6b', component.options)
    } else {
      api.reload('64bedc6b', component.options)
    }
    module.hot.accept("./ClinicHistory.vue?vue&type=template&id=64bedc6b&", function () {
      api.rerender('64bedc6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/ClinicHistory.vue"
export default component.exports